export default "__VITE_ASSET__c4e26a2d__"